import { Button, Tabs, Steps, Divider} from 'antd'
import { useState } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'
import GeneralConfig from 'Components/Macro/GeneralConfig'
import StepsConfig from 'Components/Macro/StepsConfig'
import { CreateMacroDataProvider, useCreateMacroData } from 'Components/Macro/CreateMacroDataProvider'
import WeaverService from 'Services/WeaverService'
import { save } from 'Components/Macro/helpers'


{ TabPane } = Tabs
{ Step } = Steps

CreateMacroForm = ->
  history = useHistory()
  { params: { spaceId, formId }} = useRouteMatch()

  [state, dispatch] = useCreateMacroData()
  [saving, setSaving] = useState(false)
  [current, setCurrent] = useState(0)
  
  handleCreate =  ->
    id = if formId is 'new' then undefined else formId
    try
      await save(id, state)
      await WeaverService.updateMacros()
      destroy()
    catch e
      setSaving(false)

  destroy = ->
    history.push("/#{ spaceId }/settings/forms")
  
  <>
    <div style={{ height: '100%' }}>
    <Steps
      type="navigation"
      size="small"
      current={current}
      onChange={setCurrent}
    >
      <Step key="general-config" title="General" />
      <Step key="steps" title="Steps & Fields"/>
    </Steps>
    <Divider />

    { 
      if current is 0
        <GeneralConfig />
      else
        <StepsConfig />
    }
    </div>
    <div style={ { textAlign: 'right' } }>
      <Button type='link' disabled={!current} onClick={ -> setCurrent(0)}>Previous</Button>
      <Button type='link' disabled={current} onClick={ -> setCurrent(1)}>Next</Button>
      <Button
        type="primary"
        disabled={!current}
        onClick={ -> handleCreate()}
      >Save</Button>
      <Button onClick={destroy}>Cancel</Button>
    </div>
  </>

export default ({state}) ->
  <CreateMacroDataProvider initialState={state}>
      <CreateMacroForm />
  </CreateMacroDataProvider>
